import { render, staticRenderFns } from "./PropertyCard.vue?vue&type=template&id=68a99eb8&scoped=true"
import script from "./PropertyCard.vue?vue&type=script&lang=js"
export * from "./PropertyCard.vue?vue&type=script&lang=js"
import style0 from "./PropertyCard.vue?vue&type=style&index=0&id=68a99eb8&prod&lang=scss"
import style1 from "./PropertyCard.vue?vue&type=style&index=1&id=68a99eb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a99eb8",
  null
  
)

export default component.exports